import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Observable } from 'rxjs';
import {
  Environment,
  IDshbProcDatiModel,
  IProcDatiDashboardSintesiModel,
  ProceduraDati,
  ProceduraDatiTableModel,
  ProceduraDati_RenderViewModel,
  ProcResultIModel,
  ProceduraDatiFirmeModel,
} from '../../models/-index';

@Injectable()
export class ProceduraDatiService extends CrudGenericsService<
  ProceduraDati,
  number
> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ProceduraDati`);
    this.base = `${env.apiUrl}/api/ProceduraDati/`;
  }
  // sotto ======== web =========
  public GetProceduraDati_TableModel(
    date_min: string,
    date_max: string
  ): Observable<ProceduraDatiTableModel[]> {
    const url =
      this.base +
      'GetProceduraDati_TableModel?date_min=' +
      date_min +
      '&date_max=' +
      date_max;
    return this.http.get<ProceduraDatiTableModel[]>(`${url}`);
  }

  // sotto ===== ionic =======
  AddDati_AfterCheckList(model: ProcResultIModel) {
    const url = this.base + 'AddDati_AfterCheckList';
    return this.http.post(`${url}`, model);
  }
  public GetProceduraDatiView_ById(
    id: number
  ): Observable<ProceduraDati_RenderViewModel> {
    const url = this.base + 'GetProceduraDatiView_ById?id=' + id;
    return this.http.get<ProceduraDati_RenderViewModel>(`${url}`);
  }
  public GetProceduraDatiView_AnalisiFirme_ById(
    id: number
  ): Observable<ProceduraDatiFirmeModel[]> {
    const url = this.base + 'GetProceduraDatiView_AnalisiFirme_ById?id=' + id;
    return this.http.get<ProceduraDatiFirmeModel[]>(`${url}`);
  }

  public Dashboard_Sintesi(
    id: number,
    date_min: string,
    date_max: string
  ): Observable<IProcDatiDashboardSintesiModel> {
    const url =
      this.base +
      'Dashboard_Sintesi?id=' +
      id +
      '&date_min=' +
      date_min +
      '&date_max=' +
      date_max;
    return this.http.get<IProcDatiDashboardSintesiModel>(`${url}`);
  }

  public Dashboard_FailureStep(
    id: number,
    idArea: number,
    idProdTipo: number,
    date_min: string,
    date_max: string
  ): Observable<IDshbProcDatiModel[]> {
    const url =
      this.base +
      'Dashboard_FailureStep?id=' +
      id +
      '&idArea=' +
      idArea +
      '&idProdTipo=' +
      idProdTipo +
      '&date_min=' +
      date_min +
      '&date_max=' +
      date_max;
    return this.http.get<IDshbProcDatiModel[]>(`${url}`);
  }
}
